import { animate, style, transition, trigger } from '@angular/animations';

export const FadeAnimation = trigger('fadeAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('0.5s ease-in-out', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('0.5s ease-in-out', style({ opacity: 0 }))]),
]);

export const QuickFadeAnimation = trigger('quickFadeAnimation', [
  transition(':enter', [style({ opacity: 0 }), animate('0.1s ease-in-out', style({ opacity: 1 }))]),
  transition(':leave', [style({ opacity: 1 }), animate('0.1s ease-in-out', style({ opacity: 0 }))]),
]);

export const FadeCenterAnimation = trigger('fadeCenterAnimation', [
  transition(':enter', [
    style({ opacity: 0, position: 'absolute', left: '50%', transform: 'translateX(-50%)' }),
    animate('0.5s ease-in-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }),
    animate('0.5s ease-in-out', style({ opacity: 0 })),
  ]),
]);

export const FadeFullAnimation = trigger('fadeFullAnimation', [
  transition(':enter', [
    style({ opacity: 0, position: 'absolute', width: 'calc(100% - 48px)', top: 0 }),
    animate('0.5s ease-in-out', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    style({ position: 'absolute', width: 'calc(100% - 48px)', top: 0 }),
    animate('0.5s ease-in-out', style({ opacity: 0 })),
  ]),
]);
